$(function () {

  $('a[href^="#"]').click(function () {
    let speed = 500
    let href = $(this).attr("href")
    let target = $(href == "#" || href == "" ? 'html' : href)
    let position = target.offset().top
    $("html, body").animate({ scrollTop: position }, speed, "swing")
    return false
  })

  var fadeIn = function () {
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    $('.effect-fade').each(function () {
      var elemPos = $(this).offset().top
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-scroll')
      }
    })
  }

  fadeIn()

  if ($('.js-strap-slider').length) {
    new Splide('.js-strap-slider', {
      type: 'loop',
      fixedWidth: 254,
      gap: 8,
      pagination: true,
      arrows: false,
      focus: 0,
    }).mount()
  }

  var setBtnRipplePos = function (btn, e) {
    var rect = btn.getBoundingClientRect()
    btn.style.setProperty('--btn-x', (e.clientX - rect.left) + 'px')
    btn.style.setProperty('--btn-y', (e.clientY - rect.top) + 'px')
  }

  $('.js-btn-watch').each(function () {
    var btn = this
    btn.addEventListener('mouseenter', function (e) {
      // 前回リーブ位置からの補間を止め、入った位置へ即リセット
      btn.style.setProperty('--btn-pos-duration', '0s')
      btn.style.setProperty('--btn-scale-duration', '1.1s')
      btn.style.setProperty('--btn-scale-ease', 'cubic-bezier(0.4, 0, 0.2, 1)')
      setBtnRipplePos(btn, e)
      void btn.offsetWidth
      requestAnimationFrame(function () {
        btn.classList.add('is-btn-hover')
      })
    })
    btn.addEventListener('mouseleave', function (e) {
      // 出た位置へ向けて top/left もアニメーション
      btn.style.setProperty('--btn-pos-duration', '0.8s')
      btn.style.setProperty('--btn-scale-duration', '1.1s')
      btn.style.setProperty('--btn-scale-ease', 'cubic-bezier(0.22, 1, 0.36, 1)')
      setBtnRipplePos(btn, e)
      btn.classList.remove('is-btn-hover')
    })
  })
})
